// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper {
  overflow: auto;
}
.modal-wrapper .form-container {
  padding: 1rem;
  background-color: white;
}
.modal-wrapper .form-container .header-row {
  display: flex;
  align-items: center;
  justify-self: center;
}
.modal-wrapper .form-container .header-row h6 {
  margin: 0;
  font-weight: 600;
}
.modal-wrapper .form-container .header-row .subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: var(--ion-color-medium, #6b6b6b);
}
.modal-wrapper .form-container .field-row {
  display: flex;
  margin-bottom: 32px;
}
.modal-wrapper .form-container .field-row div {
  flex-grow: 1;
  padding: 0 1rem;
  margin-bottom: 0.5rem;
}
.modal-wrapper .form-container .field-row .custom-input {
  width: 100%;
}
.modal-wrapper .form-container .field-row .error-message {
  display: block;
  color: var(--ion-color-danger, #d32f2f);
  font-size: 12px;
  margin-top: 4px;
}
.modal-wrapper .form-container .main-buttons {
  justify-content: center;
  padding: 0 0.75rem;
  flex-direction: row;
  margin-top: 2rem;
}
.modal-wrapper .form-container .main-buttons button {
  margin: 5px;
}
@media (max-width: 767px) {
  .modal-wrapper .form-container .main-buttons {
    justify-content: space-evenly;
  }
  .modal-wrapper .form-container .main-buttons button {
    margin: 5px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/modals/modal-motivo-recusa/modal-motivo-recusa.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AACN;AACM;EACE,SAAA;EACA,gBAAA;AACR;AAEM;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uCAAA;AAAR;AAII;EACE,aAAA;EACA,mBAAA;AAFN;AAIM;EACE,YAAA;EACA,eAAA;EACA,qBAAA;AAFR;AAKM;EACE,WAAA;AAHR;AAMM;EACE,cAAA;EACA,uCAAA;EACA,eAAA;EACA,eAAA;AAJR;AAQI;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AANN;AAQM;EACE,WAAA;AANR;AASM;EAVF;IAWI,6BAAA;EANN;EAQM;IACE,aAAA;EANR;AACF","sourcesContent":[".modal-wrapper {\n  overflow: auto;\n\n  .form-container {\n    padding: 1rem;\n    background-color: white;\n\n    .header-row {\n      display: flex;\n      align-items: center;\n      justify-self: center;\n\n      h6 {\n        margin: 0;\n        font-weight: 600;\n      }\n\n      .subtitle {\n        margin: 4px 0 0;\n        font-size: 13px;\n        font-weight: 400;\n        color: var(--ion-color-medium, #6b6b6b);\n      }\n    }\n\n    .field-row {\n      display: flex;\n      margin-bottom: 32px;\n\n      div {\n        flex-grow: 1;\n        padding: 0 1rem;\n        margin-bottom: 0.5rem;\n      }\n\n      .custom-input {\n        width: 100%;\n      }\n\n      .error-message {\n        display: block;\n        color: var(--ion-color-danger, #d32f2f);\n        font-size: 12px;\n        margin-top: 4px;\n      }\n    }\n\n    .main-buttons {\n      justify-content: center;\n      padding: 0 0.75rem;\n      flex-direction: row;\n      margin-top: 2rem;\n\n      button {\n        margin: 5px;\n      }\n\n      @media (max-width: 767px) {\n        justify-content: space-evenly;\n\n        button {\n          margin: 5px 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
